// FAQ Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Elements
  const faqItems = document.querySelectorAll('.shopify-block.faq__item');
  console.log('faqItems',faqItems); 
  // Toggle FAQ items
  faqItems.forEach(item => {
    console.log('item',item); 
    const question = item.querySelector('.faq__question');
    
    question.addEventListener('click', () => {
      console.log('clicked');
      // Close other items
      const currentlyActive = document.querySelector('.faq__item--active');
      if (currentlyActive && currentlyActive !== item) {
        currentlyActive.classList.remove('faq__item--active');
      }
      
      // Toggle current item
      item.classList.toggle('faq__item--active');
    });
  });
});